<template>
  <div class="d-flex flex-column justify-center border-red">
    <v-btn class="mt-4" rounded color="accent " @click="openDialog">{{ $t('welcome.button.show_message') }}</v-btn>
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';

export default {
  name: 'OnDutyNotification',
  mixins: [common, configMixin],
  props: {
    config: {
      type: Object,
    },
  },
  methods: {
    openDialog() {
      console.debug('open welcome dialog');
      this.$store.commit('welcome/setIsWelcomeDialogVisible', true);
    },
  },
};
</script>
